<template>
    <b-container fluid>
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('production_store.raw_material_approve') }}</h4>
            </template>
            <template v-slot:body>
                <b-row>
                    <b-col xs="12" sm="12" md="4">
                        <b-form-group
                        class="row"
                        label-cols-sm="12"
                        label-for="requisition_id"
                        >
                        <template v-slot:label>
                            {{ $t('production_store.requisition_id')}}
                        </template>
                        <b-form-input
                            id="requisition_id"
                            v-model="search.requisition_id"
                            placeholder=""
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col xs="12" sm="12" md="4">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="from_date"
                        >
                            <template v-slot:label>
                                {{$t('production_store.from_date')}}
                            </template>
                            <b-form-input class="form-control"
                                v-model="search.from_date"
                                placeholder="Select Date"
                                id="from_date"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col xs="12" sm="12" md="4">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="to_date"
                        >
                            <template v-slot:label>
                                {{$t('production_store.to_date')}}
                            </template>
                            <b-form-input class="form-control"
                                v-model="search.to_date"
                                placeholder="Select Date"
                                id="to_date"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="12" class="text-right">
                        <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                    </b-col>
                </b-row>
            </template>
        </iq-card>
        <b-row>
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('production_store.raw_material_approve') + ' ' + $t('globalTrans.list') }}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loadingState">
                            <b-row>
                                <b-col md="12" class="table-responsive">
                                    <b-table thead-class="bg-primary" :emptyText="$t('globalTrans.noDataFound')" show-empty bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null">
                                        <template v-slot:cell(index)="data">
                                            {{ $n(data.index + pagination.slOffset) }}
                                        </template>
                                        <template v-slot:cell(requisition_date)="data">
                                            <span class="capitalize">{{ data.item.requisition_date | dateFormat }}</span>
                                        </template>
                                        <template v-slot:cell(employee_name)="data">
                                            <span class="capitalize">{{ data.item.employee_name }}</span>
                                        </template>
                                        <template v-slot:cell(designation)="data">
                                            <span class="capitalize">{{ data.item.designation }}</span>
                                        </template>
                                        <template v-slot:cell(action)="data">
                                            <a href="javascript:" class="btn_table_action btn_green" v-b-modal.modal-4 :title="$t('globalTrans.details')" @click="view(data.item)"><i class="fas fa-eye"></i></a>
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total-rows="pagination.totalRows"
                                        @input="searchData"
                                        />
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
        <b-modal id="modal-4" size="lg" :title="$t('production_store.raw_material_approve') + ' ' + $t('production_store.details')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
            <p>
                <ViewDetails :id="viewId" :userList="userList" />
            </p>
        </b-modal>
    </b-container>
</template>
<script>
import ViewDetails from './Details'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { materialRequisitionApproveListApi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import flatpickr from 'flatpickr'

export default {
  mixins: [RouteBasedList],
  components: {
    ViewDetails
  },
  data () {
    return {
        search: {
            requisition_id: '',
            from_date: '',
            to_date: ''
        },
        DataShow: false,
        viewId: '',
        rows: [],
        userList: []
    }
  },
  computed: {
    columns () {
      const labels = [
            { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
            { label: this.$t('production_store.requisition_date'), class: 'text-left' },
            { label: this.$t('production_store.requisition_id'), class: 'text-left' },
            { label: this.$t('production_store.employee_name'), class: 'text-left' },
            { label: this.$t('production_store.designation'), class: 'text-left' },
            { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

        let keys = []

        if (this.$i18n.locale === 'bn') {
            keys = [
                { key: 'index' },
                { key: 'requisition_date' },
                { key: 'requisition_id' },
                { key: 'employee_name_bn' },
                { key: 'designation_bn' },
                { key: 'action' }
            ]
        } else {
            keys = [
                { key: 'index' },
                { key: 'requisition_date' },
                { key: 'requisition_id' },
                { key: 'employee_name' },
                { key: 'designation' },
                { key: 'action' }
            ]
        }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    currentLocale: function () {
        return this.$i18n.locale
    }
  },
  watch: {
  },
  created () {
    this.loadData()
  },
  mounted () {
    flatpickr('#from_date', {})
    flatpickr('#to_date', {})
  },
  methods: {
    view (item) {
        this.viewId = item.id
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, materialRequisitionApproveListApi, params).then(response => {
        if (response.success) {
            this.userList = response.userDetails
            this.$store.dispatch('setList', this.getRelationalData(response.data.data))
            this.paginationData(response.data)
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
        let tmpEmployee = {}
        const listData = data.map(item => {
            tmpEmployee = this.userList.find(user => user.value === item.created_by)
            const userData = {
                requisition_id: item.requisition_id !== undefined ? item.requisition_id : '',
                requisition_date: item.requisition_date !== undefined ? item.requisition_date : '',
                employee_name: tmpEmployee !== undefined ? tmpEmployee.text_en : '',
                employee_name_bn: tmpEmployee !== undefined ? tmpEmployee.text_bn : '',
                designation_id: tmpEmployee !== undefined ? tmpEmployee.designation_id : ''
            }

            const tmpDesignation = this.$store.state.commonObj.designationList.find(designation => designation.value === userData.designation_id)
            const designationData = {
                designation: tmpDesignation !== undefined ? tmpDesignation.text_en : '',
                designation_bn: tmpDesignation !== undefined ? tmpDesignation.text_bn : ''
            }
            return Object.assign({}, item, userData, designationData)
        })
        return listData
    },
    getNameReceiver (id) {
        const product = this.userList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    }
  }
}
</script>
